

























import { defineComponent } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import ChoosePostType from "../ChoosePostType";

export default defineComponent({
  name: "ChoosePostTypeController",
  components: { BaseConfirm, BaseButton, ChoosePostType },
  props: {
    showChooseType: { type: Boolean, required: true },
    postType: { type: String as () => ContentFeedTypeEnum },
    userId: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      draft: null as ContentSet | null,
    };
  },
  computed: {
    draftId(): string {
      return this.draft?.id ?? "";
    },
  },
  watch: {
    postType: {
      immediate: true,
      handler() {
        this.watchPostTypeHandler();
      },
    },
  },
  methods: {
    watchPostTypeHandler() {
      if (this.postType) {
        this.checkHasDraft();
      }
    },

    async onDeleteDraft() {
      try {
        if (!this.draftId) {
          return;
        }
        await providers.ContentSetProvider.delete({ id: this.draftId });
        this.draft = null;
      } finally {
        if (this.postType) {
          this.$emit("createPost", this.postType);
        }
      }
    },

    onUseDraft() {
      this.$emit("setPostData", this.draft);
      this.draft = null;
    },

    async checkHasDraft() {
      try {
        this.loading = true;
        const contentSetSearchResult = await providers.ContentSetProvider.search({
          data: { userId: this.userId, published: false, type: this.postType },
        });
        this.draft = contentSetSearchResult.result.find(i => !i.published) ?? null;
        if (!this.draft) {
          this.$emit("createPost", this.postType);
        }
      } finally {
        this.loading = false;
      }
    },
  },
});
